module.exports = __webpack_public_path__ + "static/media/6-Hearts.dc2bd2f4.svg";